export default __webpack_public_path__ + "static/google-play-4a9a671d1ceca8b9f8f25a5e342f8314.svg";